import { render, staticRenderFns } from "./Player-navigation.vue?vue&type=template&id=37aca7d4&scoped=true&lang=html"
import script from "./Player-navigation.vue?vue&type=script&lang=js"
export * from "./Player-navigation.vue?vue&type=script&lang=js"
import style0 from "./Player-navigation.vue?vue&type=style&index=0&id=37aca7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aca7d4",
  null
  
)

export default component.exports